export default "__VITE_ASSET__ClS$zCfa__"